import { processSteps } from "../../../mocks/services";

export default function ProcessSection() {
  return (
    <section className="py-24 lg:py-32 px-8 lg:px-14 bg-[#111111] overflow-hidden">
      <div className="flex flex-col lg:flex-row lg:items-end justify-between mb-16 gap-6">
        <div>
          <p className="text-white/40 text-xs tracking-[0.2em] uppercase mb-3">How We Work</p>
          <h2 className="font-serif text-4xl lg:text-5xl text-white font-light leading-tight">
            Our Process
          </h2>
        </div>
        <p className="text-white/50 text-sm font-light leading-relaxed max-w-sm">
          A transparent, collaborative five-phase process from first conversation to final construction.
        </p>
      </div>

      {/* Desktop: Horizontal timeline */}
      <div className="hidden lg:block">
        <div className="relative">
          {/* Timeline line */}
          <div className="absolute top-7 left-0 right-0 h-px bg-white/15" />
          <div className="grid grid-cols-5 gap-4">
            {processSteps.map((step, i) => (
              <div
                key={step.number}
                className={`pt-16 relative ${i % 2 !== 0 ? "mt-8" : ""}`}
              >
                {/* Node */}
                <div className="absolute top-5 left-0 w-5 h-5 flex items-center justify-center">
                  <div className="w-3 h-3 rounded-full bg-white/30 border border-white/50" />
                </div>
                <p className="font-serif text-5xl text-white/10 font-light mb-3">{step.number}</p>
                <h3 className="text-white text-sm font-semibold tracking-wide mb-2">{step.title}</h3>
                <p className="text-white/50 text-xs font-light leading-relaxed">{step.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Mobile: Vertical stack */}
      <div className="lg:hidden space-y-10">
        {processSteps.map((step) => (
          <div key={step.number} className="flex gap-6 items-start">
            <div className="flex-shrink-0">
              <p className="font-serif text-4xl text-white/20 font-light w-12 text-right">{step.number}</p>
            </div>
            <div className="pt-2">
              <h3 className="text-white text-sm font-semibold tracking-wide mb-2">{step.title}</h3>
              <p className="text-white/50 text-sm font-light leading-relaxed">{step.description}</p>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
